import { ListSourceType } from "@/enum/list.enum";

import { api } from "@/redux/api";

import { ListResponse, ListResponseSchema } from "../../pages/List/schema/list";

/**
 * Tracker lists for the sidebar's Feed badge (PREC-4131). Same URL as `getLeanLists`, but its own
 * endpoint on purpose: the list slice's matcher listens on `getLeanLists` and replaces the Lists /
 * Campaigns overview rows with whatever page 1 arrives, so a badge refetch (every `List` tag
 * invalidation) could otherwise overwrite the table the user is looking at with the tracker lists.
 * Same split as `getCampaignListPicker` in `campaigns-overview.api.ts`.
 */
export const sidebarTrackerListsApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getSidebarTrackerLists: builder.query<ListResponse, { limit: number }>({
			query: ({ limit }) => ({
				url: "list/lean",
				params: { page: 1, limit, sourceType: ListSourceType.TRACKER },
				responseSchema: ListResponseSchema,
			}),
			providesTags: ["List"],
		}),
	}),
});

export const { useGetSidebarTrackerListsQuery } = sidebarTrackerListsApi;
